import { Button, Col, Row } from "antd";
import Footer from "../../../components/common/Footer";
import React from "react";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

const AccountingPeriodsRightBar = [];

function AccountingPeriods() {
  return (
    <>
      <div className="page-container">
      <div className="main-container">
        <PageHeading heading="Manage Accounting Periods" />
          <Row>
            <Col className="accounting-periods-content" span={24}>
              <h4>
                Use standard Calendar Years, or define your organization's Fiscal
                Years by defining the start and end dates for each month.
              </h4>
              <p className="plain-text">Basis for Periods</p>
              <div className="calendar-year-container">
                <p className="plain-text">Calendar Year</p>
                <Button type="primary">Edit</Button>
              </div>
            </Col>
          </Row>
        <Footer />
      </div>
    </div>
    <div className="RightSidebar">
      <RightBar RightBarData={AccountingPeriodsRightBar}/>
    </div>
    </>
  );
}

export default AccountingPeriods;
